export class EmailDto{
  public fileName!:string
  public fileContent!:string
  public extension!:string
}
